var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":"https://activstoredev.blob.core.windows.net/test/WA/close.svg","height":"40px","width":"40px"}})}
var staticRenderFns = []

export { render, staticRenderFns }